import React from "react";
import BackButton from "../buttons/BackButton";
import { Link, useLocation } from "react-router-dom";

const Header = () => {
  const location = useLocation();
  return (
    <header className="flex w-full flex-shrink items-center justify-center border-b-2 border-slate-200 px-3">
      {location.pathname !== "/" && (
        <div className="absolute -top-8 left-2 flex flex-row">
          <BackButton />
        </div>
      )}
      <Link to="/">
        <h1 className="my-1 flex-auto text-center text-3xl font-bold uppercase tracking-wide md:text-4xl">
          <span className="inline-flex flex-row items-center justify-center">
            <span className="text-majky-600">WORLDLE</span>
          </span>
        </h1>
      </Link>
      <div className="absolute -top-8 right-2 flex flex-row">
        <Link
          className="mr-3 text-xl"
          title="View the Worldle - Guess the Country - how to play guide and rules"
          to="/rules"
        >
          <img
            alt="❓"
            src="/images/2753.png"
            className="mt-4 h-4 w-4 transition-all hover:mt-2 hover:h-6 hover:w-6 dark:invert"
          />
        </Link>
        {/* <Link
          className="mr-3 text-xl"
          title="Review your Worldle progress, guess distributions, max streak and current streak"
          to="/stats"
        >
          <img
            alt="📊"
            src="/images/1f4c8.png"
            className="w-4 h-4 mt-4 hover:w-6 hover:h-6 hover:mt-2 transition-all dark:invert"
          />
        </Link> */}
        <Link
          className="mr-3 text-xl"
          title="Manage your Worldle Settings"
          to="/settings"
        >
          <img
            alt="⚙️"
            src="/images/2699.png"
            className="mt-4 h-4 w-4 transition-all hover:mt-2 hover:h-6 hover:w-6 dark:invert"
          />
        </Link>
      </div>
    </header>
  );
};

export default Header;
